import styles from './Dashboard.module.scss';
import OrderBarChart from './OrderBarChart/OrderBarChart';
import ApplicationsBarChart from './ApplicationsBarChart/ApplicationsBarChart';
import FeedbackBarChart from './FeedbackBarChart/FeedbackBarChart';

interface IDashboardProps {
  startDate: string;
  endDate: string;
  assetsIds: [] | number[];
  accommodationIds: [] | number[];
  organisationIds: [] | number[];
}

const Dashboard = ({
  startDate,
  endDate,
  assetsIds,
  accommodationIds,
  organisationIds,
}: IDashboardProps) => {
  return (
    <div className={styles.dashboard}>
      <div className={styles.ordersWrapper}>
        <OrderBarChart
          startDate={startDate}
          endDate={endDate}
          assetsIds={assetsIds}
          accommodation_ids={accommodationIds}
          organization_ids={organisationIds}
        />
        <ApplicationsBarChart
          startDate={startDate}
          endDate={endDate}
          assetsIds={assetsIds}
          accommodation_ids={accommodationIds}
          organization_ids={organisationIds}
        />
      </div>
      <div className={styles.feedbackWrapper}>
        <FeedbackBarChart
          startDate={startDate}
          endDate={endDate}
          assetsIds={assetsIds}
          accommodation_ids={accommodationIds}
          organization_ids={organisationIds}
        />
      </div>
    </div>
  );
};

export default Dashboard;
